export const RouteType = Object.freeze({
  PARTNER_PROGRAM: 'PARTNER_PROGRAM',
  ASSET_CONTENT: 'ASSET_CONTENT',
  CUSTOMER: 'CUSTOMER',
  USER: 'USER',
  LOGISTIC_CENTER: 'LOGISTIC_CENTER',
  ORDER: 'ORDER',
  BRAND: 'BRAND',
  BRAND_LINE: 'BRAND_LINE',
  COUNTRY: 'COUNTRY',
  INQUIRY: 'INQUIRY',
  CUSTOMER_NESTED: 'CUSTOMER_NESTED'
})
